import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeUsers } from '../actions';
import UsersActions from '../containers/UsersActions';
import UsersPanel from '../components/UsersPanel';

export default {
  ...tabTemplate('users', UsersPanel, matchSingleUrl(['users']), UsersActions),
  ...tabCloser('closeUsersTab', closeUsers),
  ...tabIcons('users'),
  access: ({ users }) => users.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 800,
  position: 'bottom-right',
};
